import React from "react";

export default ({record}) => {
    return <span>Bannière {record.title ? `"${record.title}"` : ''}</span>;
}
